module.exports = __webpack_public_path__ + "static/media/LemonDrinks.b8fb5128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonDrinks.png
// module id = 475
// module chunks = 0